import { setAttr } from 'redom';

function getAcceptableTarget(event, editor) {

  let currentNode = event.target;

  const isEditorMainNode = currentNode.classList.contains('editor-node-main');

  if (isEditorMainNode === true) {
    return currentNode;
  }

  while (currentNode.classList.contains('editor-node-main') === false) {
    currentNode = currentNode.parentNode;

    if (currentNode == null) {
      return null;
    }
  }

  return currentNode;

}

export function makeDropZone(element, editor, options, elementPathReference) {

  function onDragOver(event) {
    event.stopPropagation();
    const acceptableTarget = getAcceptableTarget(event, editor);

    if (acceptableTarget === null) {
      return;
    }

    event.preventDefault();

    event.dataTransfer.dropEffect = 'move';

    options.onDragOver(event, acceptableTarget);

  }

  function onDrop(event) {
    event.stopPropagation();
    const acceptableTarget = getAcceptableTarget(event);

    if (acceptableTarget === null) {
      return;
    }

    event.preventDefault();

    options.onDrop(event, acceptableTarget);

  }

  function onDragEnter(event) {
    event.stopPropagation();
    const acceptableTarget = getAcceptableTarget(event);

    if (acceptableTarget === null) {
      return;
    }

    options.onDragEnter(event, acceptableTarget);

  }

  function onDragLeave(event) {
    event.stopPropagation();
    const acceptableTarget = getAcceptableTarget(event);

    if (acceptableTarget === null) {
      return;
    }

    options.onDragLeave(event, acceptableTarget);

  }

  element.addEventListener('dragover', onDragOver);
  element.addEventListener('drop', onDrop);
  element.addEventListener('dragenter', onDragEnter);
  element.addEventListener('dragleave', onDragLeave);

  return function removeDroppability() {
    // console.log('removeDroppability');
    element.removeEventListener('dragover', onDragOver);
    element.removeEventListener('drop', onDrop);
    element.removeEventListener('dragenter', onDragEnter);
    element.removeEventListener('dragleave', onDragLeave);

  };

}

export function addDraggability(element, options) {

  function onDragStart(event) {
    event.stopPropagation();
    event.dataTransfer.effectAllowed = 'move';
    event.dataTransfer.setDragImage(element.querySelector('.editor-element'), 0, 5);
    element.classList.add('moving');
    options.onDragStart(event);

  }

  element.addEventListener('dragstart', onDragStart);

  function onDragStop(event) {
    event.stopPropagation();
    event.target.classList.remove('moving');

  }

  element.addEventListener('dragend', onDragStop);

  setAttr(element, {
    draggable: true,
    ondragend: onDragStop
  });

  return function removeDraggability() {
    // console.log('removeDraggability');
    element.removeEventListener('dragstart', onDragStart);
    element.removeEventListener('dragend', onDragStop);

    setAttr(element, {
      draggable: false
    });

  };

}